import React, { Component } from 'react';
import { withRouter } from 'react-router'
import { Form, FormGroup, SubmitButton } from '../../../../components/Forms/Forms';
import { Input, Select } from '../../../../components/Forms/fields/index';
import rules from '../../../../components/Forms/rules';
import Modal from '../../../../components/Modal';
import Draggable from '../../../../components/Events/Draggable';
import enums from '../../../../constants/enums';
import config from '../../../../../../config';
import ClientModal from './ClientModal';
import Documentation from './Documentation';
import SellPaymentsPanel from './SellPaymentsPanel';
import ReleaseModal from './ReleaseModal';
import CardActionRecommendation from './CardActionRecommendation';
import CardLink from './@components/CardLink';

export class TradeDetailsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDocumentation: false,
      imageClassName: '',
      selectedImageIndex: null,
      files: null,
      showInstructions: false,
      fullsizeImage: false,
    };
    this.toggleEdit = this.toggleEdit.bind(this);
    this.toggleFullScreenImage = this.toggleFullScreenImage.bind(this);
  }

  toggleFullScreenImage() {
    this.setState({
      fullsizeImage: !this.state.fullsizeImage,
    });
  }

  openImageModal(index) {
    this.setState({
      selectedImageIndex: index,
    });
  }

  toggleInstruction() {
    this.setState({
      showInstructions: !this.state.showInstructions,
    })
  }

  closeImageModal() {
    this.setState({
      selectedImageIndex: null,
      imageClassName: '',
    })
  }

  rotateImage(){
    const classNames = ['', 'rotate-90', 'rotate-180', 'rotate-270'];
    const index = classNames.indexOf(this.state.imageClassName);
    this.setState({
      imageClassName: classNames[(index + 1) % classNames.length],
    })
  }

  nextImage(){
    const { images } = this.props.trade;
    const { selectedImageIndex } = this.state;
    this.setState({
      selectedImageIndex: (selectedImageIndex + 1) % images.length,
    });
  }

  previousImage(){
    const { images } = this.props.trade;
    const { selectedImageIndex } = this.state;
    this.setState({
      selectedImageIndex: (selectedImageIndex || images.length) - 1 ,
    });

  }

  toggleEdit(e) {
    e.preventDefault();
    this.props.toggleEdit();
  }

  renderPayments({ needToKeep, isBankCard, toggleDisputeModal, editing, formState, paymentTypes, paymentStatus, trade, addPayment, removeItem, giftcardLinks, toggleHelpRequest, toggleFlagTrade }){
    isBankCard = trade.payments.length === 0 ? isBankCard : trade.payments.find(payment=> giftcardLinks[payment.type].isBankCard);
    const payments = (editing ? formState.data : trade).payments;
    if(payments.length){
      isBankCard = payments.find(payment=> giftcardLinks[payment.type].isBankCard);
    }
    return (
      <div>
        <div className="payments">
          <div className="title">Payment Data</div>
          <table>
            <thead>
            <tr>
              <th>Code</th>
              {isBankCard ? (
                <th>CVV</th>
              ) : (
                <th>Pin</th>
              )}
              {isBankCard && (
                <th>Expiration</th>
              )}
              <th>Type</th>
              <th>Status</th>
              <th>Value</th>
              <th>Remaining</th>
            </tr>
            </thead>
            {editing ? (
              <tbody>
              {formState.data.payments.map((payment, i) => (
                <tr key={i}>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].code`} type="text" validate={[rules.required()]}/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].pin`} type="text"/>
                    </FormGroup>
                  </td>
                  {isBankCard && (
                    <td>
                      {(giftcardLinks[payment.type] || {}).isBankCard && (
                        <FormGroup>
                          <Input name={`payments[${i}].expirationDate`} type="text"/>
                        </FormGroup>
                      )}
                    </td>
                  )}
                  <td>
                    <FormGroup>
                      <Select name={`payments[${i}].type`} options={paymentTypes}
                              defaultValue={paymentTypes[0]}/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Select name={`payments[${i}].status`} options={paymentStatus}
                              defaultValue={paymentStatus[0].value}/>
                    </FormGroup>
                  </td>
                  <td>
                    <FormGroup>
                      <Input name={`payments[${i}].value`} type="number"
                             disabled={['split', 'alreadyRedeemed', 'receiptIssue'].indexOf(payment.status) > -1}/>
                    </FormGroup>
                  </td>
                  <td>{payment.remainingValue}</td>
                  <td>
                    <button type="button" onClick={() => removeItem('payments', i)}>x</button>
                  </td>
                </tr>
              ))}
              </tbody>
            ) : (
              <tbody>
              {trade.payments.map((payment, i) => {
                return (
                  <tr key={i}>
                    <td>
                      <CardLink needToKeep={needToKeep} type={payment.type} code={payment.code} pin={payment.pin} />
                    </td>
                    <td>{payment.pin}</td>
                    {isBankCard && (
                      <td>{payment.expirationDate}</td>
                    )}
                    <td>{typeof payment.type === 'string' ? payment.type : 'BAD DATA'}</td>
                    <td>{payment.status}</td>
                    <td>{payment.value}</td>
                    <td>{payment.remainingValue}</td>
                  </tr>
                )
              })}
              </tbody>
            )}
          </table>
          {editing && (
            <div className="actions">
              <button className="button" type="button" onClick={addPayment}>+</button>
            </div>
          )}
        </div>
        <div className="trade-actions">
          {editing ? (
            <div>
              <button className="button" type="button" onClick={this.toggleEdit}>Cancel</button>
              <SubmitButton className="button">Save</SubmitButton>
            </div>
          ) : (
            <div>
              <button className="button secondary" type="button" onClick={toggleHelpRequest}>{trade.helpRequested ? 'Help Not Needed' : 'Need Help'}</button>
              <button className="button secondary" type="button" onClick={toggleFlagTrade}>{trade.flagged ? 'UnFlag Trade' : 'Flag Trade'}</button>
              {trade.trade_status === 'Paid' && (
                <button className="button" type="button" onClick={()=>toggleDisputeModal(true)}>Dispute</button>
              )}
              <button className="button" type="button" onClick={this.toggleEdit}>Edit</button>
            </div>
          )}
        </div>
      </div>

    );
  }

  render() {
    const {
      trade,
      giftcardLinks,
      editing,
      toggleCheckbox,
      formState,
      paymentTypes,
      tradeStatus,
      paymentStatus,
      releaseFunds,
      markAsPaid,
      cancel,
      canceling,
      submitForm,
      onFormUpdate,
      removeItem,
      addPayment,
      toggle,
      expanded,
      isEven,
      setChatText,
      onDisputeMessageChange,
      onDisputeMessageIdChange,
      setDisputeMessageText,
      disputeMessageInputValue,
      reason_type,
      disputeMessageSubmit,
      toggleDisputeModal,
      disputeModalActive,
      disputeMessageMessages,
      chatMessages,
      history,
      setChecklistMode,
      gotToTrade,
      clientModalActive,
      toggleClientModal,
      submitFileUpload,
      releasing,
      context,
      toggleHelpRequest,
      toggleFlagTrade,
      className,
      checklistMode,
    } = this.props;
    const { selectedImageIndex } = this.state;
    const client = trade.client || {};

    const username = trade.username;
    // const username = trade.offer_type === 'buy' ? trade.responder_username : trade.username;

    const card = giftcardLinks[trade.type];
    const isBankCard = (card || {}).isBankCard;

    const needToKeep = trade.redeemRecommendation === 'keep';

    return (
      <tbody>
      <tr key={trade.tradeId} className={`${className} ${isEven ? 'even' : 'odd'} ${trade.fraud ? 'fraud' : ''}`}>
        <td>
          {context === 'open' && (
            <span className={`split-id split-id-${trade.splitId2}`}>{trade.splitId2 || 0}</span>
          )}
          &nbsp;
          {context === 'open' && (
            <span className={`split-id split-id-${trade.splitId3}`}>{trade.splitId3}</span>
          )}
          &nbsp;
          <a href={`https://paxful.com/trade/${trade.tradeId}`} target="_blank">{trade.tradeId}</a>
        </td>
        <td>
          <div className="cell-username">
            <a href={`https://paxful.com/user/${username}`}
               onClick={e => {
                 e.preventDefault();
                 toggleClientModal(true, username)
               }}
            >{username}</a>
            {client.feedback_positive ? (
              <span className="feedback-positive">+{trade.client.feedback_positive}</span>
            ) : null}
            {client.feedback_negative ? (
              <span className="feedback-negative">-{trade.client.feedback_negative}</span>
            ) : null}
          </div>
          {clientModalActive && (
            <ClientModal
              toggleClientModal={toggleClientModal}
              username={username}
            />
          )}
        </td>
        <td>{trade.date}</td>
        <td>{trade.carrier_info}</td>
        <td>{trade.offer_type}</td>
        <td>
          <a href="#"
             onClick={(e)=>{
               e.preventDefault();
               this.setState({
                 showDocumentation: true,
               });
             }}
          >{trade.type}</a>
          {this.state.showDocumentation && (
            <Documentation
              type={trade.type}
              onClose={()=>{
                this.setState({
                  showDocumentation: false,
                });
              }}
            />
          )}
        </td>
        <td>{trade.amount} ({trade.fiat_currency_code})</td>
        <td>
          {trade.trade_status}
        </td>
        <td>
          {trade.fraud && (
            <span className="fraud">Fraud</span>
          )}
        </td>
        <td>
          {trade.duplicates && trade.duplicates.map((item, i) => (
            <span className="duplicate-link" key={i}>
              {i > 0 && (<span className="separator">-</span>)}
              <a href={`https://paxful.com/trade/${item.tradeId}`}
                 onClick={e=>{
                   e.preventDefault();
                   history.push('/workArea/trades/completed?tradeId=' + item.tradeId);
                 }}
                 target="_blank"
                 className="warning"
              >{item.tradeId}</a>
            </span>
          ))}

        </td>
        <td>
          <div className="action-buttons">
            {/*<button onClick={refreshTrade} title="refresh"><i className="fi-refresh size-18"></i> refresh</button>*/}
            <button onClick={toggle}><i className="fi-arrows-out size-18"></i> view more</button>
          </div>
        </td>
        <td className="status-icons-td">
          {context === 'open' && (
            <div className="status-icons">
              <span className={`status-icon ${trade.iconClasses.photos}`}><i className="fi-photo"></i></span>
              <span className={`status-icon ${trade.iconClasses.cards}`}><i className="fi-credit-card"></i></span>
              <span className={`status-icon ${trade.iconClasses.messages}`}><i className="fi-comments"></i>
                {trade.unreadMessages > 0 && (
                  <sup>{trade.unreadMessages}</sup>
                )}
              </span>
            </div>
          )}
        </td>
      </tr>
      {expanded && (
        <tr className="expanded-trade">
          <td colSpan="12">
            <div className="trade-details">
              <div className="correspondence">
                <div className="messages">
                  <div className="title">Chat</div>
                  <CardActionRecommendation trade={trade}/>
                  <ul>
                    {(trade.instructionMessage || trade.escrowMessage) && (
                      <li className="instructions-li">
                        {this.state.showInstructions ? (
                          <div>
                            <div className="instruction-message">
                              {trade.instructionMessage}
                            </div>
                            <div className="escrow-message">
                              {trade.escrowMessage}
                            </div>
                            <div>
                              <a
                                href="#"
                                onClick={e => {
                                  e.preventDefault();
                                  this.toggleInstruction();
                                }}
                              >
                                Hide trade instructions
                              </a>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <a
                              href="#"
                              onClick={e => {
                                e.preventDefault();
                                this.toggleInstruction();
                              }}
                            >
                              View trade instructions
                            </a>
                          </div>
                        )}

                      </li>
                    )}
                    {trade.messages.map((message, i) => (
                      <li className={message.mine ? 'mine' : ''} key={i}>
                        {message.text}
                      </li>
                    ))}
                  </ul>
                  <form className="chat-form" onSubmit={e => {
                    e.preventDefault();
                    this.props.chatSubmit();
                  }}>
                    <div className="chat-input">
                      <textarea
                        name="message"
                        value={this.props.chatInputValue}
                        onChange={(e) => {
                          this.props.onChatChange(e.target.value);
                        }}
                        onKeyDown={(e)=>{
                          const keyCode = e.keyCode;
                          if (keyCode === 13 && !e.shiftKey) {
                            this.props.chatSubmit();
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                    <div className="chat-submit">
                      <button className="button" type="submit">Send</button>
                    </div>
                  </form>
                  <div className="uploadFile">
                    <form onSubmit={e=>{
                      e.preventDefault();
                      const files = this.state.files;
                      if(files && files.length){
                        // the formData object get created automatically by the  http service
                        submitFileUpload({
                          file: files[0],
                          clearInput: ()=>{
                            this.fileInputRef.value = '';
                          },
                        });
                        //
                      }


                    }}>
                      <input
                        type="file"
                        onChange={e=>{
                          const files = e.currentTarget.files;
                          this.setState({
                            files,
                          });
                        }}
                        ref={ref=>this.fileInputRef = ref}
                        multiple={false}/>
                      {this.state.files && this.state.files.length > 0 && (
                        <button type="submit" className="button">Upload</button>
                      )}
                    </form>
                  </div>
                  <div className="presetMessages">
                    <select
                      onChange={(e)=>{
                        setChatText(e.target.value);
                      }}
                      value=""
                    >
                      <option></option>
                      {trade.presetMessages.map((item, i)=>(
                        <option key={i}>{item}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="images">
                  <div className="title">Images</div>
                  <div className="thumbnails">
                    {trade.images.map((image, i) => {
                      // const imageUrl = `${config.api.default}/admin/image?id=${image.id}&token=${token}`;
                      const imageUrl = image.originalUrl;
                      return (
                        <a
                          key={i}
                          href={imageUrl}
                          onClick={e => {
                            e.preventDefault();
                            this.openImageModal(i);
                          }}
                          className="thumbnail"
                        >
                          <img src={imageUrl} alt=""/>
                          <span className="image-type">
                            {image.type}
                          </span>
                        </a>
                      );
                    })}
                  </div>
                </div>
              </div>

              <div className="payment-details">
                <Form element="div" state={formState} onSubmit={submitForm} onChange={onFormUpdate}>

                  <div className="trader-info">
                    <div className="info-item">
                      <span>Traders:</span>
                      {trade.activeTraders.join(', ')}
                    </div>
                    {trade.releasedBy && (
                      <div className="info-item">
                        <span>Released by:</span>
                        {trade.releasedBy}
                      </div>
                    )}
                    {trade.disputedBy && (
                      <div className="info-item">
                        <span>Disputed by:</span>
                        {trade.disputedBy}
                      </div>
                    )}
                    {trade.disputed && (
                      <div className="info-item">
                        <span>Disputed at:</span>
                        {(new Date(trade.disputedDate)).toLocaleString()}
                      </div>
                    )}
                  </div>
                  {trade.offer_type === 'buy' ? trade.isActiveTrade && (
                    <div>
                      <div className="checklist trade-actions">
                        {trade.trade_status !== 'Paid' && (
                          <button type="button" className="button" onClick={markAsPaid}>{releasing ? 'Marking as paid ...' : 'Mark As Paid'}</button>
                        )}
                        {(trade.trade_status !== 'Paid' || !this.props.hasSellPayments) ? (
                          <button type="button" className="button warning" onClick={cancel}>{canceling ? 'Canceling ...' : 'Cancel'}</button>
                        ) : (
                          <span>You have already made a payment so you can't cancel the order.</span>
                        )}

                      </div>
                    </div>
                  ) : (
                    <div>
                      {checklistMode === 'noCheckbox' || (trade.photoVerified && trade.cardDataInserted && trade.cardDataVerified && (!isBankCard || trade.cardRedeemed)) ? (
                        <div className="checklist">
                          <button type="button" className="button" onClick={() => releaseFunds()}>{releasing ? 'Releasing ...' : 'Release Funds'}</button>

                          {!config.disableChecklistMode && (
                            <div className="checklist-item input" style={{textAlign: 'right'}}>
                              <select value={checklistMode} onChange={(e)=>{
                                setChecklistMode(e.target.value);
                              }} style={{width: 200, margin: 0}}>
                                <option value="default">default</option>
                                <option value="noConfirm">no confirmation</option>
                                <option value="noCheckbox">no checkboxes/confirmation</option>
                              </select>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="checklist">
                          <div className="checklist-item input">
                            <label>
                              <input type="checkbox" checked={trade.photoVerified}
                                     onChange={() => toggleCheckbox('photoVerified')}/>
                              {trade.images.length ? 'Photo Verified' : 'No Photo Required'}

                            </label>
                          </div>
                          <div className="checklist-item input">
                            <label>
                              <input type="checkbox" checked={trade.cardDataInserted} disabled={!trade.payments.length}
                                     onChange={() => toggleCheckbox('cardDataInserted')}/>
                              Card Data Inserted
                            </label>
                          </div>
                          <div className="checklist-item input">
                            <label>
                              <input type="checkbox" checked={trade.cardDataVerified} disabled={!trade.payments.length}
                                     onChange={() => toggleCheckbox('cardDataVerified')}/>
                              Card Data Verified
                            </label>
                          </div>
                          {isBankCard && (
                            <div className="checklist-item input">
                              <label>
                                <input type="checkbox" checked={trade.cardRedeemed} disabled={!trade.payments.length}
                                       onChange={() => toggleCheckbox('cardRedeemed')}/>
                                Card Redeemed
                              </label>
                            </div>
                          )}
                          {!config.disableChecklistMode && (
                            <div className="checklist-item input" style={{textAlign: 'right'}}>
                              <select value={checklistMode} onChange={(e)=>{
                                setChecklistMode(e.target.value);
                              }} style={{width: 200, margin: 0}}>
                                <option value="default">default</option>
                                <option value="noConfirm">no confirmation</option>
                                <option value="noCheckbox">no checkboxes/confirmation</option>
                              </select>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}



                  {editing ? (
                    <div className="editable-data">
                      <FormGroup className="editable-item">
                        <label>Status</label>
                        <Select name="trade_status" options={tradeStatus}/>
                      </FormGroup>
                    </div>
                  ) : (
                    <div className="editable-data">
                      <div className="editable-item">
                        <label>Status</label>
                        {trade.trade_status}
                      </div>
                    </div>
                  )}

                  {selectedImageIndex !== null ? (
                    <Modal className={`modal-container gift-card-image-modal ${this.state.fullsizeImage ? 'fullsize-image' : ''}`} active={selectedImageIndex !== null} onClose={() => this.closeImageModal()}>
                      <div className="image-pagination">
                        <button className="carousel-image-prev" onClick={()=>this.previousImage()}><i className="fi-arrow-left size-18"></i></button>
                        <button className="carousel-image-next" onClick={()=>this.nextImage()}><i className="fi-arrow-right size-18"></i></button>
                        <button className="carousel-rotate-image" onClick={()=>this.rotateImage()}><i className="fi-refresh size-18"></i></button>
                        <button className="carousel-fullscreen-image" onClick={()=>this.toggleFullScreenImage()}><i className={`${this.state.fullsizeImage ? 'fi-minus' : 'fi-plus'} size-18`}></i></button>
                        <div className="pagination-title">{selectedImageIndex + 1} / {trade.images.length}</div>
                      </div>
                      <Draggable ref={(draggable)=> this.draggableImage = draggable}>
                        <img className={this.state.imageClassName} src={trade.images[selectedImageIndex].originalUrl} alt=""/>
                      </Draggable>
                      <div className="modal-payments-grid">
                        {trade.offer_type === 'sell' && this.renderPayments({ needToKeep, isBankCard, toggleDisputeModal, editing, formState, paymentTypes, paymentStatus, trade, addPayment, removeItem, giftcardLinks, toggleHelpRequest, toggleFlagTrade })}
                      </div>
                    </Modal>
                  ) : trade.offer_type === 'sell' && this.renderPayments({ needToKeep, isBankCard, toggleDisputeModal, editing, formState, paymentTypes, paymentStatus, trade, addPayment, removeItem, giftcardLinks, toggleHelpRequest, toggleFlagTrade })}

                  {trade.offer_type === 'buy' && (
                    <SellPaymentsPanel trade={trade} />
                  )}

                  {disputeModalActive && (
                    <Modal className="modal-container dispute-modal"
                           active={disputeModalActive}
                           onClose={() => toggleDisputeModal(false)}>
                      <form className="chat-form" onSubmit={e => {
                        e.preventDefault();
                        disputeMessageSubmit();
                      }}>
                        <div className="input textarea">
                          <label>Dispute Reason</label>
                          <select
                            onChange={(e) => {
                              onDisputeMessageIdChange(e.target.value);
                            }}
                            value={reason_type}
                          >
                            <option value=""></option>
                            {enums.disputeReasons.map((item, i) => (
                              <option key={item.value} value={item.value}>{item.label}</option>
                            ))}
                          </select>
                        </div>
                        <div className="input textarea">
                          <label>Reason</label>
                          <textarea
                            name="message"
                            value={disputeMessageInputValue}
                            onChange={(e) => {
                              onDisputeMessageChange(e.target.value);
                            }}
                          />
                        </div>
                        <div className="input select">
                          <label>Presets</label>
                          <select
                            onChange={(e) => {
                              setDisputeMessageText(e.target.value);
                            }}
                            value=""
                          >
                            <option></option>
                            {disputeMessageMessages.map((item, i) => (
                              <option key={i}>{item.value}</option>
                            ))}
                          </select>
                        </div>

                        <div className="chat-submit">
                          <button className="button" type="submit">Start Dispute</button>
                        </div>
                      </form>
                    </Modal>
                  )}


                </Form>

                {this.props.releaseModalActive && (
                  <ReleaseModal
                    trade={trade}
                    needToRedeem={trade.redeemRecommendation !== 'hold'}
                    toggleReleaseModal={this.props.toggleReleaseModal}
                    releaseFunds={this.props.releaseFunds}
                    releaseModalActive={this.props.releaseModalActive}
                  />
                )}
              </div>
            </div>
          </td>
        </tr>
      )}
      </tbody>

    );
  }

}

export default withRouter(TradeDetailsView);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/TradeDetails.view.js